import {Text} from '@eitje/web_components'

export const BooleanRow = ({item}) => {
	return (
		<>
			<Text t={`records.default.fields.${item.description}`} infoIconMessage={item.infoIconMessage} />
			<Text>{item.value ? 'Yes' : 'No'}</Text>
		</>
	)
}
